function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/card.ts
import { cardAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar } from "@chakra-ui/styled-system";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $bg = cssVar("card-bg");
var $padding = cssVar("card-padding");
var $shadow = cssVar("card-shadow");
var $radius = cssVar("card-radius");
var $border = cssVar("card-border-width", "0");
var $borderColor = cssVar("card-border-color");
var baseStyle = definePartsStyle({
  container: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $bg.variable, "colors.chakra-body-bg"), "backgroundColor", $bg.reference), "boxShadow", $shadow.reference), "borderRadius", $radius.reference), "color", "chakra-body-text"), "borderWidth", $border.reference), "borderColor", $borderColor.reference),
  body: {
    padding: $padding.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: $padding.reference
  },
  footer: {
    padding: $padding.reference
  }
});
var sizes = {
  sm: definePartsStyle({
    container: _defineProperty(_defineProperty({}, $radius.variable, "radii.base"), $padding.variable, "space.3")
  }),
  md: definePartsStyle({
    container: _defineProperty(_defineProperty({}, $radius.variable, "radii.md"), $padding.variable, "space.5")
  }),
  lg: definePartsStyle({
    container: _defineProperty(_defineProperty({}, $radius.variable, "radii.xl"), $padding.variable, "space.7")
  })
};
var variants = {
  elevated: definePartsStyle({
    container: _defineProperty(_defineProperty({}, $shadow.variable, "shadows.base"), "_dark", _defineProperty({}, $bg.variable, "colors.gray.700"))
  }),
  outline: definePartsStyle({
    container: _defineProperty(_defineProperty({}, $border.variable, "1px"), $borderColor.variable, "colors.chakra-border-color")
  }),
  filled: definePartsStyle({
    container: _defineProperty({}, $bg.variable, "colors.chakra-subtle-bg")
  }),
  unstyled: {
    body: _defineProperty({}, $padding.variable, 0),
    header: _defineProperty({}, $padding.variable, 0),
    footer: _defineProperty({}, $padding.variable, 0)
  }
};
var cardTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  sizes: sizes,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
});
export { cardTheme };